import { format } from 'date-fns';
import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import { Box } from 'rebass';

import Calendar from '@/components/Calendar';
import useQueryCalendar from '@/hooks/queries/useQueryCalendar';
import Appointment from '@/widgets/Projekte/Appointment';
import HeaderListAppointment from '@/widgets/Projekte/HeaderListAppointment';
import NoAppointment from '@/widgets/Projekte/NoAppointment';
import SelectedDateAppointment from '@/widgets/Projekte/SelectedDateAppointment';

const SimpleCalendar = ({ dashboard, id }) => {
  const [selectDate, setSelectDate] = useState(new Date());
  const [showAppointment, setShowAppointment] = useState('show-all');
  const { data, isSuccess } = useQueryCalendar(id);
  const today = useMemo(() => format(new Date(), 'yyyy-MM-dd'), []);

  if (!isSuccess) return <div />;

  const handleToday = () => {
    setSelectDate(today);
    setShowAppointment(today);
  };

  const handleAllList = () => {
    setSelectDate(today);
    setShowAppointment('show-all');
  };

  const filteredAppointment = data.appointment.filter((v) => v.date === showAppointment).filter((v) => v.status !== 1);
  const nextAppointment = data.appointment.filter((d) => new Date().getTime() < d.timems).filter((d) => d.status !== 1);

  return (
    <>
      <Calendar
        dashboard={dashboard}
        onSelectDate={setSelectDate}
        onSetShowAppointment={setShowAppointment}
        selectedDate={selectDate}
        appointment={data.listAllAppointment}
      >
        <Box>
          <HeaderListAppointment onReset={handleAllList} onToday={handleToday} showAppointment={showAppointment} />

          {showAppointment &&
            showAppointment !== 'show-all' &&
            filteredAppointment.length > 0 &&
            filteredAppointment.map((v) => <SelectedDateAppointment data={v} today={today} />)}

          {showAppointment === 'show-all' &&
            nextAppointment.length > 0 &&
            nextAppointment.slice(0, 5).map((v) => <Appointment data={v} today={today} />)}

          {showAppointment && showAppointment !== 'show-all' && filteredAppointment.length <= 0 && <NoAppointment />}
          {showAppointment === 'show-all' && data.appointment.length <= 0 && <NoAppointment />}
          {showAppointment === 'show-all' && data.appointment.length > 0 && nextAppointment.length <= 0 && (
            <NoAppointment />
          )}
        </Box>
      </Calendar>
    </>
  );
};

SimpleCalendar.propTypes = {
  dashboard: PropTypes.string.isRequired,
  id: PropTypes.string,
};

SimpleCalendar.defaultProps = {
  id: null,
};

export default SimpleCalendar;
